module.exports = __webpack_public_path__ + "static/media/Icons_Idle_01_Urgent.e146c37e.svg";